// extracted by mini-css-extract-plugin
export var equalColumn = "_ep-0";